import script from "./orderbekræftigelse.vue?vue&type=script&setup=true&lang=js"
export * from "./orderbekræftigelse.vue?vue&type=script&setup=true&lang=js"

import "./orderbekræftigelse.vue?vue&type=style&index=0&id=3432dd53&lang=css"

const __exports__ = script;

export default __exports__